import ConfirmEmail from './ConfirmEmail';
import './ConfirmEmail.scss';

export default ConfirmEmail;
